/**
 * Metni URL-dostu bir formata dönüştürür
 * Türkçe karakterleri İngilizce karşılıklarına çevirir
 * Boşlukları kaldırır ve özel karakterleri tire (-) ile değiştirir
 * @param str Dönüştürülecek metin
 * @returns URL-dostu metin
 */
export const slugify = (str: string): string => {
  return (
    str
      .replace(/İ/g, 'i')
      .replace(/I/g, 'i')
      .toLocaleLowerCase()
      .replace(/ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/ş/g, 's')
      .replace(/ı/g, 'i')
      .replace(/ö/g, 'o')
      .replace(/ç/g, 'c')
      .replace(/\?/g, '')
      .replace(/\s+/g, '-') // Boşlukları tire ile değiştir
      // .replace(/[^a-z0-9]/g, '-') // Özel karakterleri tire ile değiştir
      .replace(/-+/g, '-') // Birden fazla tireyi tek tireye dönüştür
      .replace(/^-|-$/g, '')
  ) // Baştaki ve sondaki tireleri kaldır
}
